import { createAction } from "@reduxjs/toolkit";

// add actions related to the group
export const selectOccupant = createAction("SET_OCCUPANT");
export const fetchOccupantAction = createAction("FETCH_OCCUPANT");
//export const saveUser = createAction("SAVE_USER");
